import * as React from "react";
import type { SVGProps } from "react";
const SvgPhoneOutgoing01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.094 2.716h5.503m0 0 .003 4.863m-.003-4.863-6.253 6.253m5.092 10.054s-1.191 1.17-1.483 1.514c-.476.507-1.037.747-1.772.747-.07 0-.146 0-.217-.005-1.399-.089-2.7-.634-3.674-1.1a20.9 20.9 0 0 1-6.954-5.435c-1.607-1.932-2.68-3.719-3.392-5.637-.438-1.17-.599-2.083-.528-2.943.047-.55.26-1.006.65-1.397l1.607-1.603c.23-.216.476-.334.716-.334.297 0 .537.179.688.33l.014.014c.287.268.56.545.848.841q.22.224.447.456l1.287 1.284c.499.498.499.959 0 1.457-.137.137-.269.273-.406.405-.395.404-.084.094-.494.46-.01.01-.02.014-.024.024-.405.404-.33.8-.245 1.067l.014.042c.335.81.806 1.57 1.522 2.478l.005.005c1.3 1.598 2.671 2.844 4.183 3.799.193.122.391.22.58.315.17.084.33.164.466.249l.057.033c.16.08.31.117.466.117.391 0 .636-.244.716-.324l.924-.922c.16-.16.414-.352.711-.352.292 0 .532.183.678.343l.01.01 2.596 2.59c.485.48.005 1.472.005 1.472"
    />
  </svg>
);
export default SvgPhoneOutgoing01;
